module.exports = __webpack_public_path__ + "resource/img/kala-2024-300px.762abe29.png";